import api from './client';

const BASE = '/api/void-reasons';

export async function fetchVoidReasons(config = {}) {
  const { data } = await api.get(BASE, config);
  return Array.isArray(data) ? data : [];
}

export async function createVoidReason(payload, config = {}) {
  const { data } = await api.post(BASE, payload, config);
  return data;
}

export async function updateVoidReason(id, payload, config = {}) {
  const { data } = await api.put(`${BASE}/${id}`, payload, config);
  return data;
}

export async function deleteVoidReason(id, config = {}) {
  await api.delete(`${BASE}/${id}`, config);
}
